import {
  Box,
  FormControl,
  FormHelperText,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { ChangeEvent } from "react";
import styled from "styled-components";
import cuideoTheme from "../../containers/themes/defaultTheme";

const StyledLabel = styled.label<{ error?: any }>`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  white-space: wrap;
  color: ${({ error }) =>
    error ? cuideoTheme.palette.error.main : cuideoTheme.palette.primary.light};
  font-size: 0.8rem;
  padding: 0.2rem 0 0.2rem 0;
  margin-bottom: 0.125rem;
`;

const StyledFormControl = styled(FormControl)<{
  isvalid?: string;
  hasadornment?: string;
}>`
  .MuiFormLabel-root {
    margin: 0.25rem 0;
  }

  .MuiOutlinedInput-root {
    height: auto;
    font-weight: 600;
    font-size: 1rem;
    color: ${cuideoTheme.palette.primary.main};
    background-color: #fff;
    &.MuiOutlinedInput-adornedStart {
      .MuiInputAdornment-positionStart {
        opacity: 0.25;
      }
    }

    &.Mui-disabled {
      background-color: #ededed;
    }

    &.Mui-error {
      color: ${cuideoTheme.palette.error.light};
      background-color: #fef5f7;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.25);
  }
`;

const StyledOption = styled(Typography)`
  font-size: 0.9375rem;
`;

interface ISimpleAutocompleteProps {
  onSelect: (newValue: string | null) => void;
  onInputChange: (newValue: string) => void;
  onBlur: () => void;
  touched?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  inputValue: string;
  value: string | null;
  isvalid?: boolean;
  required?: boolean;
  options: string[];
  name: string;
  label?: React.ReactNode;
}

const SimpleAutocomplete = (props: ISimpleAutocompleteProps) => {
  const {
    onSelect,
    onInputChange,
    onBlur,
    touched,
    hasError,
    errorMessage,
    label,
    value,
    isvalid,
    required,
    options,
    name,
  } = props;

  return (
    <Autocomplete
      id={name}
      getOptionLabel={(option) => (typeof option === "string" ? option : "")}
      filterOptions={(x) => x}
      options={value === "" ? options : []}
      includeInputInList
      filterSelectedOptions
      value={value}
      freeSolo
      onChange={(event: ChangeEvent<{}>, newValue: string | null) => {
        if (typeof newValue === "string") {
          onSelect(newValue);
        }
      }}
      onInputChange={(event, newInputValue) => {
        if (onInputChange) {
          onInputChange(newInputValue);
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <StyledFormControl
            className="CMuiFormikTextField"
            fullWidth
            error={touched && hasError}
            size="small"
            isvalid={isvalid ? "isvalid" : undefined}
          >
            <StyledLabel
              htmlFor={name}
              className="CMuiFormikTextField-label"
              error={touched && hasError}
            >
              {label} {required && " *"}
            </StyledLabel>

            <OutlinedInput
              disabled={params.disabled}
              id={params.id}
              fullWidth
              onBlur={onBlur}
              inputProps={{
                ...params.inputProps,
                autoComplete: "disable-ac",
              }}
            />
            {touched && hasError && (
              <FormHelperText>{errorMessage}</FormHelperText>
            )}
          </StyledFormControl>
        </div>
      )}
      renderOption={(option) => {
        return (
          <Box>
            <StyledOption>{option}</StyledOption>
          </Box>
        );
      }}
    />
  );
};

export default SimpleAutocomplete;
